export default {
  userTemplateList: (state) => {
    return state.detail.templates;
  },
  detail: (state) => {
    return JSON.parse(JSON.stringify(state.detail));
  }
};
